import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { giveawayLinkItemItemSelector, selectedGiveawayColorWithFallbackSelector, selectedGiveawayPrimaryColorSelector, selectedGiveawaySelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { isImagesInLoadingSelector } from '../../../redux/image-loading/image-loading.selectors';
import { saveFeedbackAction } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { GiveawayInfoPageComponent } from './giveaway-info-page';
const selector = createStructuredSelector({
  link: giveawayLinkItemItemSelector,
  giveaway: selectedGiveawaySelector,
  isImagesInLoading: isImagesInLoadingSelector,
  giveawayColor: selectedGiveawayColorWithFallbackSelector,
  backgroundColor: selectedGiveawayPrimaryColorSelector
});
const mapDispatchToProps = dispatch => ({
  saveFeedback: (linkId, message) => {
    dispatch(saveFeedbackAction({
      linkId,
      message
    }));
  }
});
export const GiveawayInfoPage = connect(selector, mapDispatchToProps)(GiveawayInfoPageComponent);